<ng-container [ngSwitch]="step$ | async">
  <app-seller-personal-data *ngSwitchCase="steps.PersonalData" (next)="cs.storePersonalData($event)"></app-seller-personal-data>

  <app-seller-bank-data
    *ngSwitchCase="steps.BusinessData"
    (next)="cs.submitSellerData($event)"
    (back)="cs.prevStep()"
  ></app-seller-bank-data>

  <app-seller-success *ngSwitchCase="steps.Success"></app-seller-success>
</ng-container>
